import React from "react";
import Modal from "react-modal";
import Cookies from "js-cookie";

export interface SwitchCountryPopupTexts {
    readonly country: string;
    readonly imageUrl: string;
    readonly title: string;
    readonly buyInfo: string;
    readonly eshopUrl: string;
    readonly buttonText: string;
}

interface SwitchCountryPopupModalProperties {
    readonly popupTexts: SwitchCountryPopupTexts;
    readonly onAfterClose?: () => void;
}

export default function SwitchCountryPopupModal({ popupTexts, onAfterClose }: SwitchCountryPopupModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(true);

    const closeModal = (): void => {
        Cookies.set("_odkctry", popupTexts.country, { expires: 7 });
        setModalIsOpen(false);
    };

    const handleGoToBuy = (): void => {
        globalThis.location.href = popupTexts.eshopUrl;
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            onAfterClose={onAfterClose}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop modal-transition"
        >
            <div className="modal-content">
                <div className="modal-header empty">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="well well-transparent language-modal-box">
                        <div className="product-row">
                            <p className="fakeh3">{popupTexts.title}</p>

                            <img className="language-modal-image" src={popupTexts.imageUrl} alt="" />

                            <p className="language-modal-info">{popupTexts.buyInfo}</p>

                            <div className="language-modal-buttons">
                                <button type="button" className="btn btn-lg btn-cart product-page-buy-button detail-new-change3" onClick={handleGoToBuy}>{popupTexts.buttonText}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
